import { Card } from '@branch-messenger/willow-ui'

import { GenericError } from '@/components/error-communications'

import { StyledRootLayoutContainer, StyledRootLayoutContent } from '../styles'
import { RootLayoutFooter } from './RootLayoutFooter'
import { RootLayoutHeader } from './RootLayoutHeader'

export const RootErrorComponent = () => {
  return (
    <StyledRootLayoutContainer>
      <RootLayoutHeader />
      <StyledRootLayoutContent>
        <Card style={{ alignSelf: 'center' }}>
          <GenericError />
        </Card>
      </StyledRootLayoutContent>
      <RootLayoutFooter />
    </StyledRootLayoutContainer>
  )
}
